export default new Map<string, { var: string; assignDefault?: string[] }>([
  [
    'linkColor',
    {
      var: 'components.link.color',
    },
  ],
]);
